import { ReactElement, Suspense } from 'react';
import { Tabs } from 'antd';
import { A_TO_Z_ACTIVE_TAB_3 } from 'utils/constants/a-to-z';
import { EIconSize } from 'utils/constants/app/ui';
import { lazy } from 'utils/generic/lazy';
import { TAtoZMenuConfigs } from 'interfaces/generic';
import { TabTitle, TabTitleWrapper } from './style';
import { GlobalIcon } from 'components/GlobalIcon';
import 'newcomponents/Shared/LeaderBoardCustomTab/index.less';

type Props = {
  setVisible: (arg: boolean) => void;
  setOpen: (arg: boolean) => void;
  page: number;
  setPage: (arg: number) => void;
  configs: TAtoZMenuConfigs;
};

const { SportPage } = lazy(
  () => import(/* webpackChunkName: "sport-page" */ './SportPage')
);

const { CasinoPage } = lazy(
  () => import(/* webpackChunkName: "casino-page" */ './CasinoPage')
);

const { TabPane } = Tabs;

export const DefaultPages = ({
  page,
  setVisible,
  setOpen,
  setPage,
  configs
}: Props): ReactElement => {
  return (
    <div className="tabsWrapper tabsWrapper--notIsCasino">
      <Tabs
        defaultActiveKey="0"
        onChange={page => setPage(Number(page))}
        destroyInactiveTabPane={true}
        tabBarStyle={{ margin: 0, height: 57 }}
      >
        <TabPane
          tab={
            <TabTitleWrapper>
              <GlobalIcon
                name="live"
                lib="sports"
                size={EIconSize._24}
                className="text-color"
              />
              <TabTitle isActive={page === 0}>Live</TabTitle>
            </TabTitleWrapper>
          }
          key="0"
        >
          <Suspense>
            <SportPage
              configs={configs}
              isLive
              setVisible={setVisible}
              setOpen={setOpen}
            />
          </Suspense>
        </TabPane>
        <TabPane
          tab={
            <TabTitleWrapper>
              <GlobalIcon
                name="upcoming"
                lib="generic"
                theme="colored"
                size={EIconSize._24}
              />
              <TabTitle isActive={page === 1}>Prematch</TabTitle>
            </TabTitleWrapper>
          }
          key="1"
        >
          <Suspense>
            <SportPage
              configs={configs}
              setVisible={setVisible}
              setOpen={setOpen}
            />
          </Suspense>
        </TabPane>
        <TabPane
          tab={
            <TabTitleWrapper>
              <GlobalIcon
                name="placeholder"
                lib="casino"
                size={EIconSize._24}
              />
              <TabTitle isActive={page === 2}>Casino</TabTitle>
            </TabTitleWrapper>
          }
          key="2"
        >
          <Suspense>
            <CasinoPage
              categoryIds={configs.categoryIds}
              setOpen={setOpen}
              setVisible={setVisible}
            />
          </Suspense>
        </TabPane>
        <TabPane
          tab={
            <TabTitleWrapper>
              <GlobalIcon
                lib="generic"
                name="casino"
                theme="colored"
                size={EIconSize._24}
              />
              <TabTitle isActive={page === A_TO_Z_ACTIVE_TAB_3}>
                Live Casino
              </TabTitle>
            </TabTitleWrapper>
          }
          key="3"
        >
          <Suspense>
            <CasinoPage
              setOpen={setOpen}
              setVisible={setVisible}
              isLiveCasino
            />
          </Suspense>
        </TabPane>
      </Tabs>
    </div>
  );
};
